import api from './api';

const WishlistService = {
    getWishlist: async () => {
        const response = await api.get('/wishlists/');
        // We assume the user has one default list for now, or returns a list of wishlists.
        // Backend returns list of wishlists.
        return response.data;
    },

    addToWishlist: async (data) => {
        // data = { product_id, note }
        const response = await api.post('/wishlists/add-item/', data);
        return response.data;
    },

    removeFromWishlist: async (wishlistId, productId) => {
        await api.delete(`/wishlists/${wishlistId}/remove-item/${productId}/`);
    }
};

export default WishlistService;
